/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";

// Configs
import { env } from "@/configs/env.config";

// Slices
import { AuthSlice, createAuthSlice } from "@/stores/slices/auth.slice";

/* -------------------------------------------------------------------------- */
/*                                   Store                                    */
/* -------------------------------------------------------------------------- */

const usePhysiomKineStore = create<AuthSlice>()(
  devtools(
    persist(
      (...a) => ({
        ...createAuthSlice(...a),
      }),
      {
        name: "_physiomKine",
        storage: createJSONStorage(() => localStorage),
      }
    ),
    { enabled: env.nodeEnv === "development" }
  )
);

export default usePhysiomKineStore;
